/**
 * 🏛️ TIER 8 BUILDINGS - Advanced Settlement
 * 
 * Unlocked by: Architecture, Religion, Grand Architecture, Monarchy
 * Cost multiplier: 610x | Prod multiplier: 26.8x
 * Costs: 35,000-100,000 | Production: 10-20/s
 * Target ROI: ~18 minutes
 */

export const TIER_08_BUILDINGS = {
  mansion: {
    id: 'mansion',
    name: 'Mansion',
    icon: '🏰',
    tier: 8,
    description: 'Luxurious housing for wealthy',
    flavor: 'Where nobility dwells.',
    baseCost: { stone: 36000, gold: 21600, iron: 12000 },
    baseProduction: { population: 13.5, gold: 5.5 },
    unlockCondition: { tech: 'architecture' },
  },

  temple: {
    id: 'temple',
    name: 'Temple',
    icon: '⛪',
    tier: 8,
    description: 'Spiritual center of the kingdom',
    flavor: 'Faith moves mountains.',
    baseCost: { stone: 48000, gold: 30000, gems: 4800 },
    baseProduction: { culture: 10.5, population: 8.0 },
    unlockCondition: { tech: 'religion' },
  },

  cathedral: {
    id: 'cathedral',
    name: 'Cathedral',
    icon: '⛪',
    tier: 8,
    description: 'Grand house of worship',
    flavor: 'Reaching toward the heavens.',
    baseCost: { stone: 72000, gold: 48000, gems: 9600 },
    baseProduction: { culture: 16.0, population: 13.5 },
    unlockCondition: { tech: 'grand_architecture' },
  },

  palace: {
    id: 'palace',
    name: 'Palace',
    icon: '🏛️',
    tier: 8,
    description: 'Seat of royal power',
    flavor: 'The crown jewel of the kingdom.',
    baseCost: { stone: 96000, gold: 60000, steel: 24000, gems: 12000 },
    baseProduction: { gold: 21.5, population: 16.0, culture: 10.5 },
    unlockCondition: { tech: 'monarchy' },
  },
};

export default TIER_08_BUILDINGS;
